/*
* Component
*
* @author				Matt Gifford
* @copyright			2020 Brigada Limited
*/
define("site/components/shopify-product", ["brigada/jquery"], (jQuery) => {
	/*
	 * @private	The private reference to this class
	 */
	const _this = {};


	/**
	 * Init
	 *
	 * @param        nodes        The component nodes to initialise
	 * @return      void
	 */
	_this.init = (nodes) => {
		nodes.forEach(function (component) {

			// Images
			if (1 < component.querySelectorAll('.photo-item').length) {
				const container = component.querySelector('.carousel');
				const slider = new Flickity(container, {
					freeScroll: false, wrapAround: true, imagesLoaded: true, watchCSS: false	// enable breakpoint support
				});
			}

			// Variants
			if (component.querySelector('.variant-selects')) {
				component.querySelectorAll('.variant-selects select').forEach(function (node) {
					node.addEventListener('click', function (e) {
						setTimeout(function () {
							_this.updateSelectedVariant(component);
						}, 100);
					});
					node.addEventListener('change', function (e) {
						setTimeout(function () {
							_this.updateSelectedVariant(component);
						}, 100);
					});
				});
				_this.updateSelectedVariant(component);
			}

			// Add to cart
			component.querySelector('.addtocart').addEventListener('submit', function (e) {
				e.preventDefault();

				if (this.classList.contains('unavailable')) {
					return;
				}

				if (!_this.productOptionsSelected(component)) {
					alert('Please select options for this product.');
					return;
				}

				if (!!document.querySelector('.component-shopify-sidebar-cart')) {
					document.body.removeChild(document.querySelector('.component-shopify-sidebar-cart'));
				}

				const formData = new FormData(this);
				const body = new URLSearchParams(formData).toString();

				document.body.classList.add('progress');
				fetch('/cart/add.js', {
					method: 'POST', body: body, headers: {
						'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'
					}, credentials: 'same-origin', // or 'omit' for no cookies
				}).then(function (response) {
					return response.ok ? response.json() : Promise.reject(response);
				}).then(function (data) {
					document.body.classList.remove('progress');
					// Success
					if (!!data.id) {
						// Show mini cart
						let event = document.createEvent('HTMLEvents');
						event.initEvent('click', true, false);
						document.querySelector('#cart-icon-bubble').dispatchEvent(event);
					}
				}).catch(function (error) {
					// Error
					document.body.classList.remove('progress');
					if (!!error.statusText) {
						if (error.statusText == 'Unprocessable Entity') {
							alert('Sorry this variant is sold out');
						} else {
							alert(error.statusText);
						}
					}
				});
			});

		});
	};


	/**
	 * Updates the price and buy button after variant option selection
	 *
	 * @param		component
	 * @return		void
	 */
	_this.updateSelectedVariant = function (component) {
		component.querySelector('.addtocart').classList.remove('unavailable');

		if (_this.productOptionsSelected(component)) {
			// Check if variant combo exists
			let selects = component.querySelectorAll('.variant-selects select');
			let id = null;
			let price = null;
			let available = false;
			for (var x = 0; x < __variants.length; x++) {
				switch (selects.length) {
					case 1:
						if (selects[0].value == __variants[x].option1) {
							id = __variants[x].id;
							price = __variants[x].price / 100;
							available = __variants[x].available;
						}
						break;

					case 2:
						if (selects[0].value == __variants[x].option1 && selects[1].value == __variants[x].option2) {
							id = __variants[x].id;
							price = __variants[x].price / 100;
							available = __variants[x].available;
						}
						break;

					case 3:
						if (selects[0].value == __variants[x].option1 && selects[1].value == __variants[x].option2 && selects[2].value == __variants[x].option3) {
							id = __variants[x].id;
							price = __variants[x].price / 100;
							available = __variants[x].available;
						}
						break;

					default:
						break;

					// end of switch
				}
			}

			if (available) {
				component.querySelector('input.variant_id').value = id;
				component.querySelector('.details > .price').innerHTML = '$' + price.toFixed(2);
			} else {
				component.querySelector('.addtocart').classList.add('unavailable');
			}
		}
	};


	/**
	 * Returns if all selections have been made
	 *
	 * @param		component
	 * @return		bool
	 */
	_this.productOptionsSelected = function (component) {
		let isSelected = true;

		component.querySelectorAll('.variant-selects select').forEach(function (node) {
			if (node.selectedIndex === 0) {
				isSelected = false;
			}
		});

		return isSelected;
	};


	// Return the object
	return _this;
});